import type { Agency } from "@/types";

export function TrialBanner({ agency }: { agency: Agency }) {
  if (agency.status === "active") return null;

  if (agency.status === "trial" && agency.trial_ends_at) {
    const endsAt = new Date(agency.trial_ends_at);
    const ms = endsAt.getTime() - Date.now();
    const days = Math.max(0, Math.ceil(ms / 86_400_000));
    const tight = days <= 7;
    return (
      <div
        className={`px-8 py-2.5 border-b text-[12px] flex items-center justify-between ${
          tight
            ? "border-amber-500/20 bg-amber-500/10 text-amber-200"
            : "border-accent-500/20 bg-accent-500/10 text-accent-400"
        }`}
      >
        <span>
          <strong className="font-semibold">Trial</strong> — {days} day
          {days === 1 ? "" : "s"} remaining (ends {endsAt.toLocaleDateString()})
        </span>
        <span className="text-[11px] opacity-80">
          Contact AgencyGrid to convert to a paid seat before your trial ends.
        </span>
      </div>
    );
  }

  if (agency.status === "past_due") {
    return (
      <div className="px-8 py-2.5 border-b border-rose-500/30 bg-rose-500/10 text-rose-200 text-[12px] flex items-center justify-between">
        <span>
          <strong className="font-semibold">Payment required</strong> — your
          AgencyGrid subscription is past due.
        </span>
        <span className="text-[11px] opacity-80">
          Contact support to restore publishing.
        </span>
      </div>
    );
  }

  if (agency.status === "suspended") {
    return (
      <div className="px-8 py-2.5 border-b border-rose-500/30 bg-rose-500/10 text-rose-200 text-[12px]">
        <strong className="font-semibold">Account suspended.</strong> Please
        contact AgencyGrid.
      </div>
    );
  }

  return null;
}
